import { get } from "../../utils/httpClient";

const clientService = () => {
  const prefixApi = "duedates/clients";

  const getClients = async () => {
    return await get(`/${prefixApi}`);
  };

  return {
    getClients,
  };
};

export default clientService;
